interface TopicItem {
  label: string;
  hot: string;
}

const topics: TopicItem[] = [
  { label: '流浪地球3', hot: '986万' },
  { label: '长安十二时辰', hot: '872万' },
  { label: '夏日追剧指南', hot: '765万' },
  { label: '高分电影推荐', hot: '698万' },
  { label: '韩剧推荐', hot: '623万' },
  { label: '国产动漫', hot: '541万' },
  { label: '纪录片精选', hot: '487万' },
  { label: '搞笑综艺', hot: '435万' },
  { label: '悬疑推理片', hot: '398万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
            大家都在搜
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时热门搜索，了解当前最受关注的影视话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#hero"
              className="group flex items-center gap-2 px-5 py-3 rounded-full border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-hashtag text-primary-400 text-sm"></i>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.hot}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}